import {
  MapContainer,
  TileLayer,
  Marker,
  Popup,
  useMap,
  ZoomControl,
} from "react-leaflet";
import L from "leaflet";
import "leaflet/dist/leaflet.css";
import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import offices from "./data/offices.json";
import MapOffice from "./MapOffice";
import {
  Box,
  Select,
  FormControl,
  FormLabel,
  Heading,
  Text,
  VStack,
  HStack,
  useTheme,
  Grid,
  GridItem,
  Button,
  Flex,
} from "@chakra-ui/react";
import { StandardHeader } from "../themes/StandardHeader";

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleDot, faHome, faLocationDot, faSquare, faSyringe } from '@fortawesome/free-solid-svg-icons';

export default function MapOfficePage() {
  const theme = useTheme();
  const navigate = useNavigate();

  return (
    <Box p={25}>
      
            <StandardHeader
              title="จุดจำหน่ายวัคซีน"
              bgColor="iTeal.500"
              icon={faLocationDot}
            />

      {/* Document Header */}
      <Box m={15} p={5} borderWidth={1} borderRadius="md" boxShadow="sm" h="800px">
        <MapOffice />
      </Box>
    </Box>
  );
}
